import { gql } from "lib/apolloClient";
import { staffFragment } from "modules/CommonFragments";

import { unitPlanFragment, staffUnitPlanFragment } from "./IBFragments";

export const getStaffListQuery = gql`
  query getStaffList(
    $searchText: String
    $grades: [ID!]
    $courses: [ID!]
    $archivalState: ARCHIVAL_STATE_ENUM
    $includeArchived: IncludeArchivedFromModuleInput
    $curriculumProgramIds: [ID!]
  ) {
    platform {
      organization {
        id
        staff(
          filters: {
            searchText: $searchText
            grades: $grades
            courses: $courses
            archivalState: $archivalState
            includeArchived: $includeArchived
            curriculumProgramIds: $curriculumProgramIds
          }
        ) {
          totalCount
          edges {
            node {
              ...staffCoursesItem
            }
          }
        }
      }
    }
  }

  ${staffUnitPlanFragment.staffCourses}
`;

export const getCourseStaffGroupQuery = gql`
  query getCourseStaffGroup(
    $searchText: String
    $grades: [ID!]
    $curriculumProgramIds: [ID!]
  ) {
    platform {
      organization {
        id
        courses(
          filters: {
            searchText: $searchText
            grades: $grades
            curriculumProgramIds: $curriculumProgramIds
          }
        ) {
          totalCount
          edges {
            node {
              id
              title
              collaborators: allCollaborators {
                totalCount
                edges {
                  node {
                    ...staffItem
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  ${staffFragment.basicStaffDetails}
`;

export const getUnitPlanQuery = gql`
  query getUnitPlan(
    $id: ID!
    $centralRepoInput: UnitCentralRepoConfigInput
    $responseFilter: ResponseFilter
    $exceptionalCollaboratorsFilter: ExceptionalCollaboratorUserFilter
    $collaboratorsFilter: CollaboratorFilters
    $libraryBannerFilters: LibraryPremiumBannerFilters
  ) {
    node(id: $id, type: UNIT_PLAN) {
      id
      ... on UnitPlan {
        id
        ...unitPlanItem
      }
    }
  }
  ${unitPlanFragment.unitPlanDetails}
`;

export const getUnitPlanResourceCountQuery = gql`
  query getUnitPlanResourceCount($id: ID!) {
    node(id: $id, type: UNIT_PLAN) {
      id
      ... on UnitPlan {
        id
        resourceLibrary {
          leCount
          assessmentCount
          worksheetCount
        }
        organizationResourcesConnection {
          totalCount
        }
      }
    }
  }
`;

export const getUnitSummaryPlanQuery = gql`
  query getUnitSummaryPlan($id: ID!, $locale: String) {
    node(id: $id, type: UNIT_PLAN) {
      id
      ... on UnitPlan {
        id
        ...unitSummaryPlanItem
      }
    }
  }
  ${unitPlanFragment.unitSummaryPlanDetails}
`;

export const getUnitPlanCollaboratorsDetailsQuery = gql`
  query getUnitPlan($id: ID!, $collaboratorsFilter: CollaboratorFilters) {
    node(id: $id, type: UNIT_PLAN) {
      id
      ... on UnitPlan {
        id
        ...unitPlanItem
      }
    }
  }
  ${unitPlanFragment.unitPlanCollaboratorDetails}
`;
